import ButtonXiaoshou from './src/main'

ButtonXiaoshou.install = function (Vue) {
    Vue.components(ButtonXiaoshou.name, ButtonXiaoshou)
}

export default ButtonXiaoshou